import BaseAPI from "./BaseAPI";
import { useLocation } from 'react-router';
//import queryString from 'query-string';

class UserAPI extends BaseAPI {
    get = async (type) => {
        let userType = "intern";
        if(type == 2) {
            userType = "extern"
        }
        var promise = await this.init().get("/account/users/"+userType);
        return promise;
    };

    getUser = async (userid) => {
        var promise = await this.init().get("/account/user/"+userid);
        return promise;
    };

    deleteUser = async (userData) => {
        let userType = "intern";
        if(userData.type == 2) {
            userType = "extern"
        }
        
        var promise = await this.init().delete("/account/user/"+userType+"/"+userData.key);
        return promise;
    };

    cretaeOTPRequest    = async (userData) => {
           var promise = await this.init().get("/account/user/"+userData.key.trim()+"/otprequest");
           return promise;
       };
	
	login = async (data) => {
        let documentRef = document.referrer;
        data.referer = documentRef; 
		var promise = await this.init().post("/account/login", data, {
            signal: AbortSignal.timeout(5000) 
        });
		return promise;
	};

    externLogin = async (data) => {
        var promise = await this.init().post("/account/externlogin/"+data.locationKey, {redirectTo:data.redirectTo}, {
            signal: AbortSignal.timeout(5000) 
        });
        return promise;
    };


    resetpassword = async (data) => {
        var promise = await this.init().post("/account/resetpassword", data);
        return promise;
    };

    resetpassword2 = async (data) => {
        var promise = await this.init().post("/account/resetpassword2/"+data.hashKey, data.data);
        return promise;
    };

    checkauth = async () => {
        
        var promise = await this.init().get("/account/auth/checklogin");
        return promise;
    };

    logout = async (data) => {
        var promise = await this.init().get("/account/logout");
        return promise;
    };

	downloadFile = async () => {
		var promise = await this.init().get("/account/downloadFile");
		return promise;
	};

	deleteFile = async (file) => {
		var promise = await this.init().delete("/account/deleteFile/"+file.key);
		return promise;
	};

    addFileDescription = async (fileId, description) => {
        var promise = await this.init().post("/account/file/"+fileId, {description:description});
        return promise;
    };

	storeUser = async (data) => {
		var promise = await this.init().post("/account/user/", data);
		return promise;
	};

    getUserInterests = async (userKey) => {
        var promise = await this.init().get("/account/interests/"+userKey);
        return promise;
    };
    getUserExperience = async (userKey) => {
        var promise = await this.init().get("/account/experience/"+userKey);
        return promise;
    };

    saveUserInterests = async (data) => {
        var promise = await this.init().post("/account/user/interests/"+data.userKey, data);
        return promise;
    };

    saveUserExperience = async (data) => {
        var promise = await this.init().post("/account/user/experience/"+data.userKey, data);
        return promise;
    };

    exportUserData = async (userKey) => {
        var promise = await this.init().get("/account/admin/user/export/"+userKey);
        return promise;
    };


    storePerson = async (data) => {
        var promise = await this.init().post("/account/person", data);
        return promise;
    };

    getAll = async (data) => {
        var promise = await this.init().post("/account/usercompany", data);
        return promise;
    };
	
}

export default new UserAPI();